import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import assetUrl from '../../assetUrl';
import './CertifiedZigzag.css';

export default function CertifiedZigzag() {
  const { t } = useLanguage();
  const z = t.homeZigzag;

  const rows = [
    {
      image: assetUrl('/images/home-zigzag-1.jpg'),
      title: z.row1Title,
      text: z.row1Text,
      reverse: false,
    },
    {
      image: assetUrl('/images/home-zigzag-2.jpg'),
      title: z.row2Title,
      text: z.row2Text,
      reverse: true,
    },
  ];

  return (
    <section className="certified-zigzag" aria-label={z.row1Title}>
      {rows.map((row) => (
        <article
          key={row.title}
          className={`zz-band ${row.reverse ? 'zz-band--flip' : ''}`}
        >
          <div className="zz-band-inner">
            <div className="zz-visual">
              <div className="zz-visual-frame">
                <img src={`${row.image}?v=2`} alt="" loading="lazy" />
              </div>
            </div>

            <div className="zz-content">
              <span className="zz-rule" aria-hidden="true" />
              <h3>{row.title}</h3>
              <p>{row.text}</p>
            </div>
          </div>
        </article>
      ))}
    </section>
  );
}
